export default "__VITE_ASSET__CjxfX94i__"